import type {SlotGameStore} from "@gamzix/slot_core";

import {CONST} from "../../../src/const";

class ExpandWildsComponent extends Game.src.component.BaseComponent {

    protected TIME_MOVE_SYMBOL = 250;

    static events = {
        ANIM_EXPAND_WILD_TO_FINISH: "ExpandWildsComponent.ANIM_EXPAND_WILD_TO_FINISH",
    }

    async playAnimation() {
        const expandReels = [...Array.from(new Set((this.store.gameData.replace.map(data => data.x))))];
        expandReels.sort();

        for (let index = 0; index < expandReels.length; index++) {
            const reelId = expandReels[index];
            let isReelExpanded = false;

            for (let rowId = 0; rowId < CONST.ROWS; rowId++) {
                const symbolData = this.store.gameData.reels[reelId][rowId];

                if (symbolData.symbol == CONST.SYMBOLS.WILD && !isReelExpanded) {
                    await this.playExpandWildsOnReel(reelId);
                    isReelExpanded = true;
                }
            }
        }
    }

    async playExpandWildsOnReel(reelId: number) {
        let wildRowId = this.store.gameData.reels[reelId].findIndex(symbolData => symbolData.symbol == CONST.SYMBOLS.WILD);
        const wildFirstRowId = wildRowId;

        // spawn down
        for (let rowId = wildRowId; rowId < CONST.ROWS; rowId++) {
            const symbolData = this.store.gameData.reels[reelId][rowId];

            if (symbolData.symbol != CONST.SYMBOLS.WILD) {
                await this.playExpandWildTo(reelId, wildRowId, rowId);
                wildRowId = rowId;
            }
        }

        wildRowId = wildFirstRowId;

        // spawn up
        for (let rowId = wildRowId; rowId >= 0; rowId--) {
            const symbolData = this.store.gameData.reels[reelId][rowId];

            if (symbolData.symbol != CONST.SYMBOLS.WILD) {
                await this.playExpandWildTo(reelId, wildRowId, rowId);
                wildRowId = rowId;
            }
        }
    }

    async playExpandWildTo(reelId: number, from: number, to: number) {
        const fromSymbol = this.reelset.getSymbol(reelId, from);
        const toSymbol = this.reelset.getSymbol(reelId, to);

        const symbol = new ReelsetComponent.src.SymbolView();


        symbol.reelId = reelId;
        symbol.rowId = to;

        symbol.id = CONST.SYMBOLS.WILD;

        if(game.builder.isResourcesLoaded(ReelsetComponent.src.SymbolView.config[CONST.SYMBOLS.WILD]["EXPAND"])){
            symbol.playAnimation("EXPAND");
        } else {
            symbol.playAnimation("EXPAND_NOT_LOADED");
        }

        //@ts-ignore
        const symbolView = symbol.view;

        symbolView.visible = false;
        this.view.addChild(symbol);

        await Promise.all([
            game.utils.GameUtils.playScaleYoyoAnimation(symbolView, {scaleFrom: 1, scaleTo: 1.6, time: this.TIME_MOVE_SYMBOL * 0.8}),
            game.utils.GameUtils.playMoveAnimation(symbolView, {fromElement: fromSymbol, toElement: toSymbol, time: this.TIME_MOVE_SYMBOL,
                onStart: () => {
                    symbolView.visible = true
                },
                onFinish: () => {
                    game.emit(ExpandWildsComponent.events.ANIM_EXPAND_WILD_TO_FINISH);
                }
            })
        ]);

        toSymbol.id = CONST.SYMBOLS.WILD;
        toSymbol.playIdle();

        this.store.gameData.reels[reelId][to].symbol = CONST.SYMBOLS.WILD;

        await game.utils.delay(300);
        game.utils.PIXIUtils.remove(symbol);
    }

    get reelset() {
        return <any>game.component.reelset;
    }

    get store(): SlotGameStore {
        return <SlotGameStore>game.store;
    }


    getFSMHandlers() {
        return {
            SHOW_WIN: {
                expandWilds: {
                    on: async () => {
                        await this.playAnimation();
                    },
                    check: () => this.store.gameData.hasReplace()
                }
            }
        }
    }
}

// @ts-ignore
Game.src.component.ExpandWildsComponent = ExpandWildsComponent;
